<template>
  <div>
    <b-row>
      <p>Пошук <b-icon icon="search"></b-icon></p>
    </b-row>
    <b-row>
      <b-form-input
        class="w-75 m-auto"
        size="sm"
        v-model="searchString"
        placeholder="Призвіще або номер"
      >
      </b-form-input>
    </b-row>
    <b-row class="searchList mt-3 ms-2">
      <b-list-group v-for="client in clientList" :key="client.id">
        <b-list-group-item class="mt-1" v-on:click="chooseClient(client.id)">
          {{ client.surname }} {{ client.name }}
        </b-list-group-item>
      </b-list-group>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ClientSearchBar",
  data: function () {
    return {
      searchString: "",
      clientList: [],
    };
  },
  watch: {
    searchString: function (newVal) {
      if (!newVal.length || newVal.length < 3) {
        this.clientList = [];
        return;
      }
      this.searchClients(newVal);
    },
  },
  methods: {
    async searchClients(val) {
      let response = await this.$api.clients.searchClients(val);
      this.clientList = response.data;
    },
    chooseClient(id) {
      this.$emit("clientChosen", id);
    },
  },
};
</script>

<style scoped>
.searchList {
  max-height: 55vh;
  overflow: auto;
}
</style>
